<template>
  <div id="content">
    <Header :titulo="nomeEstabelecimento"></Header>
    <div class="content-wrap">
      <div>
        <router-view
          :EstabelecimentoId="estabelecimentoId"
          :DadosEstabelecimento="dadosEstabelecimento"
        />
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from "@/components/template/Header";
import Footer from "@/components/template/Footer";

export default {
  name: "Cardapios-Home",
  components: {
    Header,
    Footer
  },

  data() {
    return {
      nomeUrl: this.$route.params.nomeUrl,
      estabelecimentoId: "",
      nomeEstabelecimento: "Emennu",
      dadosEstabelecimento: null
    };
  },

  watch: {
    $route(to) {
      this.nomeUrl = to.params.nomeUrl;
    }
  },

  computed: {
    stateDadosEstabelecimento() {
      return this.$store.state.dadosEstabelecimento
    }
  },

  created() {
    if (!this.stateDadosEstabelecimento)
      this.obterDadosEstabelecimento(this.nomeUrl);
  },

  methods: {
    async obterDadosEstabelecimento(nomeURLApresentacao) {
      try {
        await this.$firebase
          .firestore()
          .collection("estabelecimentos")
          .where("nomeURLApresentacao", "==", nomeURLApresentacao)
          .get()
          .then(snapshot => {
            if (snapshot.empty) {
              console.log("Estabelecimento não encontrado: ", this.nomeUrl);
              this.notfound = true;
            } else {
              snapshot.forEach(doc => {
                this.estabelecimentoId = doc.id;
                this.nomeEstabelecimento = doc.data().nomeFantasia;
                this.dadosEstabelecimento = doc.data();
                this.dadosEstabelecimento.estabelecimentoId = doc.id;

                const configuracoes = {}
                this.$firebase
                  .firestore()
                  .collection("estabelecimentos")
                  .doc(doc.id)
                  .collection("configuracoes")
                  .get()
                  .then(snapshot => {
                    if (!snapshot.empty) {
                      snapshot.forEach(docConfig => {
                        if (docConfig.data().tipo === 'paginas')
                          configuracoes.paginas = docConfig.data()
                        else if (docConfig.data().tipo === 'links')
                          configuracoes.links = docConfig.data()
                        else if (docConfig.data().tipo === 'redessociais')
                          configuracoes.redessociais = docConfig.data()
                      });

                      this.$store.commit('UPDATE_CONFIGURACOES', configuracoes)
                    }
                  })
                  .catch(err => {
                    console.log("Erro Firebase (obterDadosEstabelecimento - configuracoes)", err);
                  })
              });
            }
          })
          .catch(err => {
            console.log("Erro Firebase (obterDadosEstabelecimento)", err);
            this.errored = true;
          })
          .finally(() => {
            this.loading = false
          });

        this.$store.commit('UPDATE_THEME', this.dadosEstabelecimento.configuracoes.themeCssClass)
        this.$store.commit('UPDATE_DADOS_ESTABELECIMENTO', this.dadosEstabelecimento)

      } catch (err) {
        console.log("Erro Firebase (obterEstabelecimento)", err);
        this.errored = true;
      }
    }
  }
};
</script>

<style scoped></style>
